import { formatDateTime } from '@/lib/campaign-dashboard'
import type { AdminMonitoringPayments } from '@/types/api'
import styles from './MonitoramentoPage.module.css'

interface MonitoringKpisProps {
  payments: AdminMonitoringPayments
}

export function MonitoringKpis({ payments }: MonitoringKpisProps) {
  const items = [
    { label: 'PIX criados (15 min)', value: String(payments.created_last_15m) },
    { label: 'PIX pagos (15 min)', value: String(payments.paid_last_15m) },
    { label: 'PIX pendentes (15 min)', value: String(payments.pending_last_15m) },
    { label: 'Último pagamento', value: formatDateTime(payments.last_paid_at) },
  ]

  return (
    <section className={styles.section} aria-label="Indicadores de pagamento">
      <h2 className={styles.sectionTitle}>Pagamentos</h2>
      <div className={styles.kpiGrid}>
        {items.map((item) => (
          <article key={item.label} className={styles.kpiCard}>
            <p className={styles.kpiLabel}>{item.label}</p>
            <p className={styles.kpiValue}>{item.value}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
